import { Flex, Icon, Text, chakra } from '@chakra-ui/react'
import { useTranslation } from '@infraloop/i18n'
import { LuEye } from 'react-icons/lu'
import { Link as RouterLink } from 'react-router'

/** Chakra-styled react-router link, so returning to your own dashboard is client-side. */
const BackLink = chakra(RouterLink)

const AdminViewBanner = ({
  userLabel,
}: {
  /** Email (or id) of the user whose dashboard is being viewed. */
  userLabel: string
}) => {
  const { t } = useTranslation()

  return (
    <Flex
      align="center"
      gap="10px"
      px="16px"
      py="10px"
      mb="16px"
      bg="primary.50"
      border="1px solid"
      borderColor="primary.200"
      borderRadius="12px"
      flexWrap="wrap"
      data-testid="admin-view-banner"
    >
      <Icon as={LuEye} boxSize="16px" color="primary.600" flexShrink={0} />
      <Text fontSize="13px" color="primary.800" fontWeight="medium">
        {t('hatsuly.adminViewBanner.viewing', { user: userLabel })}
      </Text>
      <BackLink
        to="/"
        ml="auto"
        fontSize="13px"
        fontWeight="semibold"
        color="primary.600"
        textDecoration="underline"
        _hover={{ color: 'primary.700' }}
        data-testid="admin-view-banner-back"
      >
        {t('hatsuly.adminViewBanner.back')}
      </BackLink>
    </Flex>
  )
}

export default AdminViewBanner
